import { UseMutationOptions } from '@tanstack/react-query';

import { CuredApiPaths, ApiMethods } from '../../models/enums';
import useMutation from '../useMutation';

import MutationKeys from './keys';

type ArchiveContentInput = {
    id: number;
    type: string;
};

const useArchiveContent = (mutateOptions?: UseMutationOptions<unknown, Error, ArchiveContentInput>) =>
    useMutation<ArchiveContentInput>(
        MutationKeys.ARCHIVE_CONTENT,
        CuredApiPaths.CONTENT_ARCHIVE,
        mutateOptions,
        ApiMethods.POST
    );

export default useArchiveContent;
